import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { HomePage, AdminHomePage, NotFoundPage, UITestPage } from './pages';
import { LoginPage, RegisterPage, ResetPasswordPage } from './pages/auth';
import { AdventureSelectionPage } from './pages/lobby';
import { ScenePage } from './pages/game';
import AuthTestPage from './pages/AuthTestPage';
import { ProtectedRoute, PublicRoute } from './components/auth';
import ToastContainer from './components/ui/ToastContainer';
import { portraitService } from './services/portraitService';
import { initializeStorageMigration } from './utils/storageMigration';

function App() {
  // Initialize storage migration on app startup
  // This must run before any auth restoration to handle HTTP ↔ HTTPS scheme changes
  useEffect(() => {
    // Initialize storage migration first
    initializeStorageMigration();
    
    // Then load portrait registry
    portraitService.loadRegistry().catch((error) => {
      console.warn('Failed to load portrait registry on app init:', error);
      // Continue gracefully - portraits will fall back to placeholders
    });
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/ui-test" element={<UITestPage />} />
          <Route path="/auth-test" element={<AuthTestPage />} />
          
          {/* Authentication routes - redirect if already authenticated */}
          <Route 
            path="/auth/login" 
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            } 
          />
          <Route 
            path="/auth/register" 
            element={
              <PublicRoute>
                <RegisterPage />
              </PublicRoute>
            } 
          />
          <Route 
            path="/auth/reset-password" 
            element={
              <PublicRoute>
                <ResetPasswordPage />
              </PublicRoute>
            } 
          />
          
          {/* Protected routes - require authentication */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminHomePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/adventures" 
            element={
              <ProtectedRoute>
                <AdventureSelectionPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/scene/:sessionId/:playerId" 
            element={
              <ProtectedRoute>
                <ScenePage />
              </ProtectedRoute>
            } 
          />
          
          {/* Legacy route - redirect to debug page for old URLs without playerId */}
          <Route 
            path="/scene/:sessionId" 
            element={
              <ProtectedRoute>
                <ScenePage />
              </ProtectedRoute>
            } 
          />
          
          {/* 404 route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      
      {/* Toast Container - outside main content wrapper */}
      <ToastContainer />
    </Router>
  );
}

export default App;
